import { useTranslation } from 'react-i18next';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { useChatControl } from 'features/toolbar/toolbar/controls/chat/useChatControl';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';
import React from 'react';

const ChatControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const { t } = useTranslation('room');

  const { active, togglePanel, unreadCount, icon, isFeatureAvailable } = useChatControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    togglePanel();
  };

  return (
    <MobileMenuItem
      icon={icon}
      badgeContent={unreadCount}
      badgeActive
      selected={active}
      onClick={handleClick}
    >
      {t('toolbar.chat')}
    </MobileMenuItem>
  );
};

export default ChatControlMobile;
